import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L, TS_Checkbox, TS_Radio } from '@nu-art/thunderstorm-frontend/index';
import { dispatch_discussionViewOptionsChanged, ModuleFE_Discussion, storage_FilterSelected } from '@app/hcs-frontend';
const Const_ShowResolvedDiscussions = 'All comments';
const Const_HideResolvedDiscussions = 'Unresolved only';
export class DiscussionsView_FilterOptionsMenu extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { id: 'filtering-options', children: [_jsx(TS_Checkbox, { className: 'filtering-options__show-only-selected', checked: storage_FilterSelected.get(false), onCheck: () => {
                        const newValue = !storage_FilterSelected.get(false);
                        storage_FilterSelected.set(newValue);
                        dispatch_discussionViewOptionsChanged.dispatchUI();
                        this.forceUpdate();
                    }, children: "Remember Selection" }), _jsx(TS_Radio, { className: 'filtering-options-radio', values: [Const_ShowResolvedDiscussions, Const_HideResolvedDiscussions], groupName: 'resolved-option', checked: ModuleFE_Discussion.shouldShowResolvedDiscussions() ? Const_ShowResolvedDiscussions : Const_HideResolvedDiscussions, onCheck: (value) => {
                        const stateDidChange = ModuleFE_Discussion.setShouldShowResolvedDiscussions(value === Const_ShowResolvedDiscussions);
                        if (stateDidChange)
                            dispatch_discussionViewOptionsChanged.dispatchUI();
                    } })] });
    }
}
//# sourceMappingURL=DiscussionView_FilterOptionsMenu.js.map